document.querySelectorAll<HTMLElement>('.logo-slider').forEach((slider) => {
	const wrapper = slider.querySelector<HTMLElement>('.logo-slider__wrapper');
	const nextButton = slider.querySelector<HTMLElement>('.logo-slider__button--next');
	const prevButton = slider.querySelector<HTMLElement>('.logo-slider__button--prev');

	if (!wrapper || !nextButton || !prevButton) return;

	const slideCount = wrapper.querySelectorAll('.swiper-slide').length;

	const updateNavigationVisibility = (swiper: typeof window.Swiper): void => {
		const isNavigationHidden = slideCount <= swiper.loopedSlides;

		wrapper.parentElement?.classList.toggle('swiper-no-arrows', isNavigationHidden);
	};

	new (window as Window).Swiper(wrapper, {
		slidesPerView: 3,
		spaceBetween: 4,
		loop: true,
		centerInsufficientSlides: true,
		navigation: {
			nextEl: nextButton,
			prevEl: prevButton,
		},
		breakpoints: {
			576: {
				slidesPerView: 3,
				spaceBetween: 4,
			},
			768: {
				slidesPerView: 4,
			},
			992: {
				slidesPerView: 7.4,
			},
		},
		on: {
			init(swiper: typeof window.Swiper) {
				updateNavigationVisibility(swiper);
			},
			breakpoint(swiper: typeof window.Swiper) {
				updateNavigationVisibility(swiper);
			},
		},
	});
});
